<ng-container *ngIf="product$ | async as product">
  <div class="cx-general-product-info">
    <div class="cx-title">
      <span> {{ product.name }} </span>
    </div>
    <button (click)="triggerDetails()">
      <ng-container *ngIf="!showMore">
        <div class="cx-toggle-details-link-text">
          {{ 'configurator.header.showMore' | cxTranslate }}
        </div>
        <cx-icon [type]="iconTypes.CARET_DOWN"></cx-icon>
      </ng-container>

      <ng-container *ngIf="showMore">
        <div class="cx-toggle-details-link-text">
          {{ 'configurator.header.showLess' | cxTranslate }}
        </div>
        <cx-icon [type]="iconTypes.CARET_UP"></cx-icon>
      </ng-container>
    </button>
    <div class="cx-details" [class.open]="showMore">
      <div class="cx-details-image">
        <cx-media
          [container]="product?.images?.PRIMARY"
          format="product"
        ></cx-media>
      </div>
      <div class="cx-details-content">
        <div class="cx-detail-title">
          <span *ngIf="product.name"> {{ product.name }} </span>
        </div>
        <div class="cx-code">
          <span *ngIf="product.code"> {{ product.code }} </span>
        </div>
        <div class="cx-description">
          <span *ngIf="product.description"> {{ product.description }} </span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
